import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { initMockMode } from './mocks/mockMode';

const App = lazy(async () => {
  await import('./i18n');
  return import('./App');
});

const mount = document.getElementById('root');
if (!mount) {
  throw new Error('Missing #root element');
}

const root = createRoot(mount);

void initMockMode();

root.render(
  <Suspense fallback={null}>
    <App />
  </Suspense>,
);
